import { VaultAssetInstallationEntityType } from '~/codegen/graphql'

const STATIC_ENTITY_ICONS: Record<
  Exclude<VaultAssetInstallationEntityType, typeof VaultAssetInstallationEntityType.Repository>,
  string
> = {
  [VaultAssetInstallationEntityType.Team]: 'light:users',
  [VaultAssetInstallationEntityType.User]: 'light:user',
  [VaultAssetInstallationEntityType.Organization]: 'light:building',
  [VaultAssetInstallationEntityType.Bot]: 'light:robot',
}

export function getInstallationIcon(entityType: VaultAssetInstallationEntityType, provider?: string | null): string {
  if (entityType === VaultAssetInstallationEntityType.Repository) {
    return getRepositoryProviderIcon(provider)
  }
  return STATIC_ENTITY_ICONS[entityType] ?? 'light:circle-question'
}

export function getRepositoryProviderIcon(provider?: string | null): string {
  switch (provider?.toLowerCase()) {
    case 'github':
      return 'brands:github'
    case 'gitlab':
      return 'brands:gitlab'
    case 'bitbucket':
      return 'brands:bitbucket'
    default:
      return 'light:code'
  }
}
